<template>
	<div class="Tieba">
		<div class="navhengfu"><span class="navtxt" >没券看方案？不存在的，注册就送！注册就送！注册就送！赢体育YYDS！</span></div>
		
		<!--<div class="notice">
			<div style="width: 100%;display: flex;cursor: pointer;">
				<el-carousel class="lunbo" height="35" direction="vertical">
					<div style="display: flex;align-items: center;justify-content: right;margin-right: 482px;"><img src="@/static/icons/noticeIcon.png" alt=""><span>公告：</span></div>
					<el-carousel-item v-for="(item, index) in ruleTipLists" :key="index">
						<span @click="ruleShow(index)">{{ item }}</span>
					</el-carousel-item>
				</el-carousel>
			</div>
		</div>-->
		<div class="c_cent">
			<!-- 热门方案 -->
			<div class="hotTopic">
				<div class="hotTopicTitle" data-intro="门派高手各抒己见，对赛事详细分析，让你对赛果有更清晰的掌握" data-step="1">
					<div class="hotTopicName">
						<img src="@/static/icons/fangan_zq.png" alt="">
						<a > 足球方案</a>
						
						
					</div>
				</div>
				<div class="titnav">
					<a @click="hotTopicStatusCli(2)" :class="hotTopicStatus==2?'active':''"><span>推荐</span></a>
				
					<a @click="hotTopicStatusCli(0)" :class="hotTopicStatus==0?'active':''"><span>最新</span></a>
					
					<a @click="hotTopicStatusCli(3)" :class="hotTopicStatus==3?'active':''"><span>免费</span></a>
				
					<a @click="hotTopicStatusCli(1)" :class="hotTopicStatus==1?'active':''"><span>我的关注</span></a>
				</div>
				<div class="gameTopicList" id="scroll-container">
					<div class="gameTopicItem" v-for="(matchItem,matchIndex) in topicList" @click="toArticlePage(matchItem)" :key="matchIndex">
						<div class="outbox" v-if="matchItem.match">
							<img :src="matchItem.userInfo.thumb?pubImg(matchItem.userInfo.thumb):require('@/static/img/defaultAvatar.png')" :onerror="require('@/static/img/defaultAvatar.png')" alt="" class="userImg">
							<div class="gameTopicCent">
								<div class="gameCentTitle">
									<el-tag :type="matchItem.match.kind==1?'info':
										matchItem.match.kind==2?'danger':
										matchItem.match.kind==3?'waring':''" effect="plain" size="small">
										{{ matchItem.match.kind==1?'让球':
										matchItem.match.kind==2?'大小球':
										matchItem.match.kind==3?'胜负平':'竞彩让球' }}
									</el-tag>
									<span class="nameTitle">{{matchItem.title}}</span>
									<!--<div @click.stop @click="uidStatus(matchItem.uid)?'':interest(matchItem,'user')">
										<span :class="uidStatus(matchItem.uid)?'grcyInterest':''">{{uidStatus(matchItem.uid)?'已关注':'@关注'}}</span>
									</div>-->
									<a class="ltlv">命中率<b>{{ matchItem.userInfo.lv_w }}</b>%</a>
									<a v-if="matchItem.is_free!=0" :style="matchItem.looks!=0 ? 'top:36%' : 'top:18%' " >需要{{matchItem.coins}}Y币<font v-if="matchItem.looks!=0"><br/>已有<b style="color:red" > {{matchItem.looks}} </b>解锁</font></a>
									<a v-if="matchItem.is_free==0" class="freecoins">免费福利</a>
								</div>
								<div class="gameCentNum">
									<span @click.stop @click="toUserHome(matchItem.uid)">{{matchItem.userInfo.username}}
										
									</span>
									<div class="saveTagBox" v-if="matchItem.userInfo.saveTag.length!=0">
										<span @click.stop @click="toUserHome(matchItem.uid)" v-for="(val,key,i) in matchItem.userInfo.saveTag" :class="saveTagBg(key)" v-if="val" v-show="i<3">{{ val }}</span>
									</div>
									<span class="timeclass">发布于{{new Date().toaddtime(matchItem.create_time)}}</span>
									<span @click.stop @click="toTiebaDetails(matchItem.pubInfo.id)">来自 {{matchItem.pubInfo.name}}</span>
									<el-divider color="#B6CBF0" direction="vertical"></el-divider>
									<span>{{isFreeText(matchItem.is_free)}}</span>
									<!-- <span>近4中4</span> -->
								</div>
							</div>
							<img class="mrsimg" style="width: 55px;height: 55px;image-rendering: -webkit-optimize-contrast; /* 处理模糊代码 */" v-if="matchItem.match.mrs!=0" v-show="matchItem.match.mrs!=3" :src="matchItem.match.mrs!=1?require('@/static/icons/mrs1.png'):require('@/static/icons/mrs2.png')" alt="" />
						</div>
					</div>
					<div v-if="loading" v-html="loadingstr"></div>
					<div v-if="topicList.length==0" class="emtype">
						<img src="@/static/icons/empty.png" alt="">
						<div>暂无数据</div>
					</div>
				</div>
				
			</div>
		</div>
		<div class="c_left">
			<!-- 左上 -->
			<!--<div class="handleBox" v-if="!userData">
				<img class="logo" src="@/static/img/indexLogo.png" alt="">
				<div class="handleBtn"><span @click="toLogin"><img src="@/static/icons/tiebaLogin.png" alt="">登录</span><span @click="toRegister"><img src="@/static/icons/tiebaRegister.png" alt="">注册</span></div>
				<div class="release"><span @click="postTopic">发布方案</span></div>
			</div>
			<div class="handleBox" v-if="userData" data-intro="创建或管理自己的门派，也可以发布对赛事的分析见解" data-step="2">
				<div class="userInfo">
					<img class="Avatar" :src="userData.thumb?pubImg(userData.thumb):require('@/static/img/defaultAvatar.png')" alt="">
					<div class="unerName"><div>{{userData.username}}<span @click="outLogin">退出</span></div></div>
					<div class="release1"><span @click="toPostBar">我的门派</span><span @click="postTopic">发布方案</span></div>
				</div>
			</div>-->
			<!-- 左下火热门派
			<div class="hotSect">
				<div class="hotSectOut">
					<div class="hotSectTitle">
						<div class="sectTitleLeft">
							<img src="@/static/icons/hotSect.png" alt="">
							<span>火热门派</span>
						</div>
						<div class="sectTitleright"  @click="toTieba">
							<span>成为掌门</span>
							<img src="@/static/icons/more.png" alt="">
						</div>
					</div>
				</div>
				<div class="hotSectList">
					<div class="hotSectItem" v-for="(pubItem,pubIndex) in pubHots" :key="pubIndex" @click="toTiebaDetails(pubItem.id)">
						<img :src="pubImg(pubItem.thumb)" alt="">
						<div class="box">
							<div class="box_title">
								<div class="sectName">
									{{pubItem.name}}｜<span> 粉丝{{pubItem.fans}}</span>
								</div>
								<div @click.stop :class="['interest',numStatus(pubItem.id)?'grcyInterest':'']" @click="interest(pubItem)">{{numStatus(pubItem.id)?'已关注':'@关注'}}</div>
							</div>
							<div class="box_cent">
								{{pubItem.domain}}
							</div>
						</div>
					</div>
				</div>
			</div>-->
      <!--高手榜-->
      <div class="hotuser hotSect">
        <div class="hotSectOut">
        	<div class="hotSectTitle">
        		<div class="sectTitleLeft">
        			<img src="@/static/icons/hotSect.png" alt="">
        			<span>高强专家</span>
        		</div>
        	</div>
        </div>
		<div class="teams">
			<div v-for="(barItem,barItemIndex) in barList" :key="barItemIndex" @click="barNavCli(barItemIndex,barItem.id)">
				<span>{{barItem.name}}</span>
				<el-divider color="#06C631" v-if="barIndex==barItemIndex"></el-divider>
			</div>
		</div>
        <div class="hotSectList">
        	<div class="hotSectItem" v-for="(userItem,userIndex) in userHots" :key="userIndex" @click="toUserHome(userItem.uid)">
        		<img :src="userItem.usr.thumb?pubImg(userItem.usr.thumb):require('@/static/img/defaultAvatar.png')" :onerror="require('@/static/img/defaultAvatar.png')" alt="">
        		<div class="box">
        			<div class="box_title">
        				<div class="sectName">
        					{{userItem.usr.username}}｜<span> 粉丝{{userItem.usr.fans}}</span>
        				</div>
        				<div @click.stop :class="['interest',numStatusUser(userItem.uid)?'grcyInterest':'']" @click="interestUser(userItem)">{{numStatusUser(userItem.uid)?'已关注':'@关注'}}</div>
        			</div>
        			<div class="box_cent">
        				方案量:{{userItem.match_count}}|命中:{{userItem.win_count}}|命中率:<font color="red">{{userItem.lv_w}}%</font>
        			</div>
        		</div>
        	</div>
        </div>
      </div>
			<!-- 猜球 -->
			<!-- <div class="guessBall">
				<div class="guessBallOut">
					<div class="guessBallTilte">
						<div class="sectTitleLeft">
							<img src="@/static/icons/guess.png" alt="">
							<span>猜球</span>
						</div>
						<div class="sectTitleright">
							<img src="@/static/icons/more.png" alt="">
						</div>
					</div>
				</div>
				<div class="guessBallCent">
					<div class="guessCentItem" v-for="(guessItem,guessIndex) in guessBallList" :key="guessIndex">
						<div class="ballTeam" @click="toTeam(guessItem.x.id)">
							<img class="ballTeamPic" :src="guessItem.x.icon" alt="">
							<div>{{guessItem.x.name}}</div>
						</div>
						<div class="ballTeamLines">
							<Progress :guessStatus="guessStatus=0" :percentageValue="percentageValue=(guessItem.x.a_lv)" :perStyle="perStyle"></Progress>
							<Progress :guessStatus="guessStatus=1" :percentageValue="percentageValue=(guessItem.x.b_lv)" :perStyle="perStyle"></Progress>
						</div>
						<div class="ballTeam yTeam" @click="toTeam(guessItem.y.id)">
							<img class="ballTeamPic" :src="guessItem.y.icon" alt="">
							<div>{{guessItem.y.name}}</div>
						</div>
					</div>
				</div>
			</div>-->
			<!-- 足球积分榜 -->
			<div class="Billboard">
				<div class="BillboardTitle">
					<div :class="newIndex==0?'scoreSelect':'scoreBoard'" @mouseover="changeIndex(0)" @click="changeIndex(0)">足球积分榜</div>
					<div :class="newIndex!=0?'otherSelect':'otherBoard'" @mouseover="changeIndex(1)" @click="changeIndex(1)">足球射手版榜</div>
				</div>
				<div class="teams">
					<div v-for="(scoreNavItem,scoreNavIndex) in scoreNavList" :key="scoreNavIndex" @click="scoreNavCli(scoreNavIndex)">
						<span>{{scoreNavItem.name}}</span>
						<el-divider color="#06C631" v-if="newScorceNavInd==scoreNavIndex"></el-divider>
					</div>
				</div>
				<div class="" v-if="newIndex==0">
					<div class="BillboardNav">
						<span>排名</span>
						<span>俱乐部</span>
						<span>胜</span>
						<span>平</span>
						<span>负</span>
						<span>积分</span>
					</div>
					<div class="BillboardTable">
						<div class="BillboardItem" v-for="(scoreItem,scoreIndex) in scoreList" :key="scoreIndex" @click="toTeam(scoreItem[0])">
							<span>{{++scoreIndex}}</span>
							<span :title="textRep(scoreItem[1])">{{textRep(scoreItem[1])}}</span>
							<span>{{scoreItem[2]}}</span>
							<span>{{scoreItem[3]}}</span>
							<span>{{scoreItem[4]}}</span>
							<span>{{scoreItem[5]}}</span>
						</div>
					</div>
				</div>
				<div class="scorersList" v-else>
					<div class="BillboardNav">
						<span>排名</span>
						<span>点球</span>
						<span>球员</span>
						<span>球队</span>
					</div>
					<div class="BillboardTable">
						<div class="BillboardItem" v-for="(scorerItem,scorerIndex) in scorerList" :key="scorerIndex" @click="toTeam(scorerItem[0])">
							<span>{{++scorerIndex}}</span>
							<span>{{scorerItem[3]}}</span>
							<span :title="textRep(scorerItem[2])">{{textRep(scorerItem[2])}}</span>
							<span :title="textRep(scorerItem[1])">{{textRep(scorerItem[1])}}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 登录弹框 -->
		<div class="loginShow">
			<el-dialog title="用户登录" @close="loginClose" :visible.sync="loginDialog" top="20vh">
			  <el-form class="formCent" :model="ruleForm" status-icon ref="ruleForm" label-width="0" @submit.native.prevent="() => submitForm()">
			    <el-form-item prop="username">
			      <el-input placeholder="请输入用户名或手机号" v-model="ruleForm.username" autocomplete="off">
			  		<template slot="prefix"><img src="@/static/icons/userIcon.png" class="icons" alt=""></template>
			  	</el-input>
			    </el-form-item>
			    <el-form-item prop="password">
			      <el-input type="password" placeholder="请输入密码" v-model="ruleForm.password" autocomplete="off">
			  		<template slot="prefix"><img src="@/static/icons/pwdIcon.png" class="icons" alt=""></template>
			  	</el-input>
			    </el-form-item>
			    <el-form-item prop="AuthCode" class="phoneCode">
			  		<el-input placeholder="验证码" v-model="ruleForm.AuthCode">
			  			<template slot="prefix"><img src="@/static/icons/codeIcon.png" class="icons" alt=""></template>
			  			<template slot="suffix"><img :src="captchaImg" alt="" @click="getCaptcha()"></template>
			  		</el-input>
			    </el-form-item>
				<el-form-item prop="AuthCode" class="phoneBox" v-if="phoneCapShow">
				<el-input placeholder="手机验证码" v-model="phone.vcode">
					<template slot="prefix"><img src="@/static/icons/codeIcon.png" class="icons" alt=""></template>
					<template slot="suffix"><div class="phoneCap" @click="codeText=='获取验证码'?getCode():''">{{codeText}}</div></template>
				</el-input>
				</el-form-item>
			    <el-form-item>
			      <el-button type="primary" native-type="submit" class="loginBtn">登录</el-button>
			  	<div class="forgotPwd">忘记密码？</div>
			  	<div class="toRegister" @click="toRegister">还没有账号？<span>去注册</span></div>
			    </el-form-item>
			  </el-form>
			</el-dialog>
			<el-dialog title="登录/注册" @close="loginClose" :visible.sync="telDialog" top="20vh">
				<el-form class="formCent" :model="ruleTelForm" status-icon ref="ruleTelForm" label-width="0" @submit.native.prevent="() => submitTel()">
					<el-form-item prop="tel">
					<el-input placeholder="请输入手机号" v-model="ruleTelForm.tel" autocomplete="off">
						<template slot="prefix"><img src="@/static/icons/userIcon.png" class="icons" alt=""></template>
					</el-input>
					</el-form-item>
					<el-form-item prop="vcode" class="phoneBox">
					<el-input placeholder="手机验证码" v-model="ruleTelForm.vcode">
						<template slot="prefix"><img src="@/static/icons/codeIcon.png" class="icons" alt=""></template>
						<template slot="suffix"><div class="phoneCap" @click="codeText=='获取验证码'?getCode():''">{{codeText}}</div></template>
					</el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" native-type="submit" class="loginBtn">登录/注册</el-button>
						<div class="forgotPwd" @click="changelog">密码登录</div>
					</el-form-item>
				</el-form>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import Progress from '@/components/BattleProgress'
	import Pagination from "@/components/Pagination.vue";
	import http from "@/api/http.js";
	// import { mapActions } from "vuex";

	export default {
	    data() {
	      return {
			hotTopicStatus:2,
			loadingstr:'加载中',
			pageover:true,
			guessStatus:0,
			percentageValue:0,
			loading: false, // 加载状态标志位
			isRuleShow:false,
				ruleVal:'',
			imageUrl: '',
			pubHots:[],
      userHots:[],
			topicList:[],
			uploadUrl:`${this.GLOBAL.base_url}/file/uploadPicture`,
			newIndex:0,
			guessBallList:[],
			scoreNavList:[
				{name:'英超',mtid:'1000'},
				{name:'意甲',mtid:'1002'},
				{name:'德甲',mtid:'1004'},
				{name:'西甲',mtid:'1005'},
				{name:'法甲',mtid:'1007'},
			],
			newScorceNavInd:0,
			barList:[
				{name:'近7榜',id:'4'},
				{name:'周榜',id:'1'},
				{name:'月榜',id:'2'},
				{name:'总榜',id:'0'},
			],
			barIndex:0,
			scoreList:[],
			scorerList:[],
			loginDialog:false,
			telDialog:false,
			ruleForm: {
				username: '',
				password: '',
				AuthCode: '',
				token:''
			},
			ruleTelForm:{
				tel:'',
				vcode:'',
				token:''
			},
			codeText:'获取验证码',
			codeTimes:300,
			perStyle:{
			  pkDetailCon:'210',
			  tips:'13',
			  voteNums:'12',
			  progress:'7',
			  progressBar:'7'
			},
			captchaImg:'',
			phoneCapShow:false,//手机验证码显示
			phone:{
				vcode: '',
				token:''
			},
			nameVal:0,
			userData:{},
			total: 1, //总条数
			page: 1, //当前页数
			limit: 30, //当前条数
			ruleTipList:[],
			currentTabList:['新注册会员将赠送3天VIP体验卡(10次方案查看,历史方案免费查看)','在赢体育获得的收益，在缴纳8%个人所得税后，用户最高可获得85%的分成！'],
	      };
	    },
		created() {
			this.$emit('changeIsShow','true');
			this.userData = JSON.parse(localStorage.getItem('userInfo'))
			this.getHotSect();
			  this.barIndex = 0
			  this.getHotUser(4);
			this.getTopicList();
			this.getGuessBall();
			this.getScoreList();
			this.getScorerList();
		},
		mounted() {
			let isWizard = localStorage.getItem('isWizard');
			if (isWizard==1) {
				this.introFun()
			}
			this.$nextTick(() => {
				const container = document.getElementById('scroll-container');
				window.addEventListener('scroll', this.handleScroll);
			});
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll);
		},
		components:{
			Progress,
			Pagination
		},
		computed:{
			pubImg(){
				return (thumb)=>{
					if (thumb.indexOf('https')!=-1) {
						return thumb
					} else{
						return (this.GLOBAL.baseUrl+thumb)
					}
				}
			},
			textRep(){
				return (item)=>{
					return item.replaceAll("'","")
				}
			},
			isFreeText(){
				return (item)=>{
					if (item==1) {
						return '收费帖'
					} if (item==2) {
						return '预测不中全返'
					} if (item==3) {
						return '关注我即免费'
					}
				}
			},
			isFreeClass(){
				return (item)=>{
					if (item==2) {
						return 'buzhongquan'
					} if (item==3) {
						return 'fensi'
					}else {
						return ''
					}
				}
			},
			numStatus(){
				return (id)=>{
					let userData = JSON.parse(localStorage.getItem('userInfo'));
					if (userData==null) {
						return false;
					}else {
						let focuspub = userData.focuspub
						if (focuspub==null) {
							return false;
						}
						let arr = focuspub.map(item=>{
							let ind = item.indexOf('|')
							return item.substring(0,ind);
						})
						let status = arr.indexOf(id)==-1?false:true
						return status
					}
				}
			},
			numStatusUser(){
				return (id)=>{
					let userData = JSON.parse(localStorage.getItem('userInfo'));

					if (userData==null) {
						return false;
					}else {
						let focususer = userData.focususer;

						if (focususer==null) {
							return false;
						}
            if (focususer=="") {
            	return false;
            }

						let arr = focususer.map(item=>{
              return item;
						})
						let status = arr.indexOf(id)==-1?false:true
						return status
					}
				}
			},
			saveTagBg(){
				return (key)=>{
					//console.log(key,888)
					switch (key) {
						case 'b':
							return 'lian';
						break;
						case 'c':
							return 'week';
						break;
						case 'd':
							return 'mother';
						break;
						case 'e':
							return 'season';
						break;
						default:
							break;
					}

				}
			},
		},
		props:{
			 ruleTipLists:{type:Array}
		},
	    methods: {
			// ...mapActions(['getUserInfo']),
			toLogin(){
				this.$router.push({name:'Login'})
			},
			toRegister(){
				this.$router.push({name:'Register'})
			},
			toTieba(){
				this.createSuccessShow = false;
				setTimeout(()=>{
					this.$router.push({name:'PostBar'})
				},300)
			},
			toPostBar(){
				this.$router.push({name:'PostBar'})
			},
			toArticlePage(item){
				let Detail = this.$router.resolve({name:'ArticlePage',query:{id:item.id}})
				window.open(Detail.href,'_blank')
			},
			toTiebaDetails(id){
				let Detail = this.$router.resolve({name:'TiebaDetails',query:{id:id}})
				window.open(Detail.href,'_blank')
			},
			toUserHome(uid){
				let Detail = this.$router.resolve({name:'UserHome',query:{uid:uid}})
				window.open(Detail.href,'_blank')
			},
			toGameTieba(id){
				let Detail = this.$router.resolve({name:'GameTieba',query:{mid:id}})
				window.open(Detail.href,'_blank')
			},
			changelog(){
				//this.telDialog = false;
				this.loginDialog = true;
			},
			ruleShow(ind){
				 // this.isRuleShow = true
                // console.log(ind,99)
                this.$emit('ruleShowCli',ind)
            },
			barNavCli(index,id){
				this.barIndex = index
				this.getHotUser(id)
			},
			hotTopicStatusCli(ind){
				let _this = this;
				if (ind==this.hotTopicStatus) return;
				if(ind==1){
					let token = localStorage.getItem('token');
					if(token==''||token==null||token==undefined){
						this.$message('请先登录！');
						this.getCaptcha()
						setTimeout(()=>{
							_this.telDialog = true;
						},300)
						return
					}
					http.post('login/checkToken',{token:token}).then(res=>{
							if (res.data.code==90002) {
								_this.$message.warning(' 用户信息超时,请登录！');
								// store.dispatch('getUserInfo',{})
								localStorage.clear();
								_this.getCaptcha()
								setTimeout(()=>{
									_this.telDialog = true;
								},300)
								return
							}else{
								let userData = res.data.data.useInfo
								localStorage.setItem('userInfo',JSON.stringify(userData));
								localStorage.setItem('token',userData.token);
							}
						})
				}
				this.hotTopicStatus = ind;
				this.page = 1;
				this.getTopicList()
			},
			// 获取一个新的图形验证码
			getCaptcha() {
				http.get('login/getcaptcha').then(res=>{
					if (res.data.code==1) {
						this.captchaImg = res.data.data.img
						this.ruleForm.token = res.data.data.token
					}
				})
			},
			//发布方案
			postTopic(){
				this.$router.push({name:'PostTopic'})
			},
			//退出登录
			outLogin(){
				http.get('login/logout').then(res=>{
					if (res.data.code==1) {
						// const store = this.$store;
						this.$message.success(res.data.msg);
						// store.dispatch('getUserInfo',{})
						localStorage.clear();
						this.$emit('changeUser',{})
						this.$router.go(0)
					}

				})
			},
			//登录弹框关闭
			loginClose(){
				this.ruleForm = {
					username: '',
					password: '',
					AuthCode: ''
				};
				this.loginDialog = false;
				this.ruleTelForm={
					tel:'',
					vcode:'',
					token:''
				};
				this.telDialog = false;
			},
			introFun(){
				let _this = this;
				let step = 0;
				this.$intro.onbeforechange(()=>{
						// 点击下一步导航前的回调
					})
					.onchange((e)=>{
						step = Number(e.getAttribute('data-step'));
					}).onafterchange(()=>{
						// 点击下一步导航后的回调
					}).oncomplete(function () {
						//点击结束按钮后， 执行的事件
						// _this.$refs.child.secWizard();
						_this.$router.push({name:'GuessBall'})
					}).onexit(()=>{//跳过按钮执行的事件
						if (step<2) {
							localStorage.setItem('isWizard',0);
						}
					})
				this.$intro.start()
			},
			//关注
			interest(pubItem){
				let token = localStorage.getItem('token');
				if(token==''||token==null||token==undefined){
					this.$message('请先登录！');
					this.getCaptcha()
					this.telDialog = true;
					return
				}
				http.post('login/checkToken',{token:token}).then(res=>{
					if (res.data.code==90001) {
						let status = this.numStatus(pubItem.id)
						let userData = res.data.data.useInfo
					localStorage.setItem('userInfo',JSON.stringify(userData));
					localStorage.setItem('token',userData.token);
						http.post('pub/focusPub',{pid:pubItem.id,status:status?0:1,uid:userData.id,token:localStorage.getItem('token')}).then(res=>{
							if (res.data.code==1) {
								this.$message.success(res.data.msg);
								userData.focuspub = res.data.data.focuspub
								localStorage.setItem('userInfo',JSON.stringify(userData));
								this.getTopicList()
							}else{
								this.$message.error(res.data.msg);
							}
						})

					}else{
						// const store = this.$store;
						this.$message(' 用户信息超时,请登录！');
						localStorage.clear();
						// store.dispatch('getUserInfo',{})
						this.getCaptcha()
						this.telDialog = true;
					}
				})
			},
      //关注
      interestUser(pubItem){
      	let token = localStorage.getItem('token');
      	if(token==''||token==null||token==undefined){
      		this.$message('请先登录！');
      		this.getCaptcha()
      		this.telDialog = true;
      		return
      	}
      	http.post('login/checkToken',{token:token}).then(res=>{
      		if (res.data.code==90001) {
      			let status = this.numStatusUser(pubItem.uid)
      			let userData = res.data.data.useInfo
					localStorage.setItem('userInfo',JSON.stringify(userData));
					localStorage.setItem('token',userData.token);
      			http.post('user/focusUser',{uid:pubItem.uid,status:status?0:1}).then(res=>{
      				if (res.data.code==1) {
      					this.$message.success(res.data.msg);
      					userData.focususer = res.data.data.focususer
      					localStorage.setItem('userInfo',JSON.stringify(userData));
      					this.getHotSect();
                this.getHotUser(this.barIndex!=0?(--this.barIndex):4);
      				}else{
      					this.$message.error(res.data.msg);
      				}
      			})

      		}else{
      			// const store = this.$store;
      			this.$message(' 用户信息超时,请登录！');
      			localStorage.clear();
      			// store.dispatch('getUserInfo',{})
      			this.$emit('changeActiveStep',false);
      			this.getCaptcha()
      			this.telDialog = true;
      		}
      	})
      },
			//登录弹框
			submitForm(){
				let reg1 = /^[a-zA-Z0-9]{6,}$/;
				let reg2 = /^[0-9]{11}$/;
				if (!this.ruleForm.username) {
					return this.$message({
						message:'手机号不能为空！',
						type: 'warning'
					});
				}
				if (!this.ruleForm.password) {
					return this.$message({
						message:'密码不能为空！',
						type: 'warning'
					});
				}else if(!reg1.test(this.ruleForm.password)){
					return this.$message({
						message:'请输入至少6位的英文或数字设置密码！',
						type: 'warning'
					});
				}
				if (!this.ruleForm.AuthCode) {
					return this.$message({
						message:'验证码不能为空！',
						type: 'warning'
					});
				}
				if (this.phoneCapShow) {
					if (!this.phone.vcode) {
						return this.$message({
							message:'手机验证码不能为空！',
							type: 'warning'
						});
					}
				}
				//验证手机验证码
				if (this.phoneCapShow) {
					http.post('login/checkVcode',{...this.phone}).then(res=>{
						 if (res.data.code==1) {
							this.login('1')
						 }else{
							 this.$message.error(res.data.msg);
						 }
					}).catch(err=>{
						console.log(err);
					})
				}else {
					this.login('0')
				}
			},
			login(nameVal){
				//登录
				let _this = this;
				http.post('login/logonAjax',{...this.ruleForm,is_succ: nameVal}).then(res=>{
					 if (res.data.code===1) {
						this.ruleForm = {
							username: '',
							password: '',
							AuthCode: ''
						};
						this.$message.success(res.data.msg);
						this.loginDialog = false
						//token储存
						localStorage.setItem('token',res.data.data.token)
						let val = res.data.data;
						//let cookData = {token:val.token,username:encodeURIComponent(val.username),saveDingzhi:val.saveDingzhi,saveGongNeng:val.saveGongNeng,level:val.level,zsvip:val.zsvip,zsvipTime:val.zsvipTime,id:val.id,thumb:val.thumb,amountAll:val.amountAll,coupons:val.coupons,couponsCount:val.couponsCount,couponsTime:val.couponsTime};
						//_this.$cookie.set('userInfo', JSON.stringify(val),{ expires: 1, domain:'yingtiyu.com'})
						_this.$cookie.set('userInfo', val.token,{ expires: 1, domain:'.yingtiyu.com'});
								// store.dispatch('getUserInfo',res.data.data)
						localStorage.setItem('userInfo',JSON.stringify(res.data.data))
						this.$router.go(0)
					 }else{
						 if (res.data.data.length>0) {
						 	this.ruleForm.username = res.data.data[0];
						 	this.phoneCapShow = true;
						 }else{
							 if (!this.phoneCapShow) {
							 	this.getCaptcha()
							 }
						 }
						 this.$message.error(res.data.msg);
					 }
				}).catch(err=>{
					console.log(err);
				})
			},
			submitTel(){
				let reg2 = /^[0-9]{11}$/;
				if (!this.ruleTelForm.tel) {
					return this.$message({
						message:'手机号不能为空！',
						type: 'warning'
					});
				}else if(!reg2.test(this.ruleTelForm.tel)){
					return this.$message({
						message:'请输入11位的手机号码！',
						type: 'warning'
					});
				}
				if (!this.ruleTelForm.vcode) {
					return this.$message({
						message:'手机验证码不能为空！',
						type: 'warning'
					});
				}
				http.post('login/regBytel',{...this.ruleTelForm}).then(res=>{
					 if (res.data.code===1) {
						this.ruleTelForm = {
							// username: '',
							// password: '',
							tel:'',
							vcode: '',
							token:''
						};
						this.$message({
							message:res.data.msg,
							type: 'success'
						});
						this.telDialog = false;
						//token储存
						localStorage.setItem('token',res.data.data.token)
						let val = res.data.data;
						
						// store.dispatch('getUserInfo',res.data.data)
						localStorage.setItem('userInfo',JSON.stringify(res.data.data))
						this.$emit('changeUser',val);
						//let cookData = {token:val.token,username:encodeURIComponent(val.username),saveDingzhi:val.saveDingzhi,saveGongNeng:val.saveGongNeng,level:val.level,zsvip:val.zsvip,zsvipTime:val.zsvipTime,id:val.id,thumb:val.thumb,amountAll:val.amountAll,coupons:val.coupons,couponsCount:val.couponsCount,couponsTime:val.couponsTime};
						//_this.$cookie.set('userInfo', JSON.stringify(val),{ expires: 1, domain:'yingtiyu.com'})
						_this.$cookie.set('userInfo', val.token,{ expires: 1, domain:'.yingtiyu.com'});
						
						this.$router.go(0)
					 }else{
						 this.$message.error(res.data.msg);
					 }
				}).catch(err=>{
					console.log(err);
				})

			},
			//获取验证码
			getCode(){
				let userName = (this.ruleForm.username) ? this.ruleForm.username : this.ruleTelForm.tel ;
				let reg2 = /^[0-9]{11}$/;
				if (!userName) {
					return this.$message({
						message:'手机号不能为空！',
						type: 'warning'
					});
				}
				if(!reg2.test(userName)){
					return this.$message({
						message:'请输入11位的手机号码！',
						type: 'warning'
					});
				}
				http.post('login/getVcode',{tel:userName}).then(res=>{
					 if (res.data.code===1) {
						this.phone.token = res.data.data.token
						this.ruleTelForm.token = res.data.data.token
						this.$message.success(res.data.msg)
						this.codeText = this.codeTimes+'s'
						let times =  setInterval(()=>{
							if (this.codeTimes<=0) {
								clearInterval(times)
								this.codeText = '获取验证码'
							} else{
								this.codeTimes--
								this.codeText = this.codeTimes+'s'
							}
						},1000)
					 }else{
						 this.$message.error(res.data.msg);
					 }
				}).catch(err=>{
					console.log(err);
				})
			},
			//积分榜
			changeIndex(index){
				this.newIndex = index
				if (index) {
					this.getScorerList();
				} else{
					this.getScoreList(1);
				}
			},
			scoreNavCli(index){
				this.newScorceNavInd = index
				if (this.newIndex) {
					this.getScorerList();
				} else{
					this.getScoreList(1);
				}
			},
			//获取积分榜列表
			getScoreList(num){
				let jfmtId = this.scoreNavList[this.newScorceNavInd].mtid
				http.get(`home/getjf_arr/${jfmtId}`).then(res=>{
					let scoreList = res.data.data
					if (scoreList.length!=0 || num!=undefined) {
						this.scoreList = res.data.data
					}else{
						this.newScorceNavInd++
						if (this.newScorceNavInd>(this.scoreNavList.length-1)) {
							this.newScorceNavInd = 0
							this.newIndex = 1
							this.getScorerList()
							return
						}
						this.getScoreList()
					}
				})
			},
			//获取射手榜列表
			getScorerList(){
				let ssmtId = this.scoreNavList[this.newScorceNavInd].mtid
				http.get(`home/getss_arr/${ssmtId}`).then(res=>{
					if (res.data.code==1) {
						this.scorerList = res.data.data
					}

				})
			},
			//获取热门方案列表
			getTopicList(){
				this.pageover = true;
				let url = 'home/article_news/0';
				switch(this.hotTopicStatus){
					case 0:
					url = 'home/article_news/0';
					break;
					case 1:
					url = 'home/FPubArticleList';
					break;
					case 2:
					url = 'home/TjianArticleList';
					break;
					case 3:
					url = 'home/articlefree';	
					break;
				}
				http.get(`${url}/${this.page}/${this.limit}`).then(res=>{
					if (res.data.code==1) {
						this.total = res.data.data.count
						this.topicList = res.data.data.list
						//console.log(this.topicList,88)
					}

				})
			},
			pageChange(e) {
			  //接收分页页面传过来的页数并调用logInfo再次渲染日志页面
			  this.page = e;
			  this.loading = true;
			  this.getTopicList();
			},
			limitChange(e) {
			  //接收分页页面传过来的条数并调用logInfo再次渲染日志页面
			  this.limit = e;
			  this.loading = true;
			  this.getTopicList();
			},
			//火热门派
			getHotSect(){
				http.get('home/pub_hots').then(res=>{
					if (res.data.code==1) {
						this.pubHots = res.data.data
					}

				})
			},
      getHotUser(ind){
        http.get(`home/gethotuser/${ind}`).then(res=>{
        	if (res.data.code==1) {
        		this.userHots = res.data.data;
        	}
        })
      },
			//猜球
			getGuessBall(){
				http.get('home/guess_hots').then(res=>{
					if (res.data.code==1) {
						this.guessBallList = res.data.data
					}

				})
			},
			//跳转球队
			toTeam(teamId){
				let teamLink = `${this.GLOBAL.linkBaseUrl}/dt/team_info.html?tid=${teamId}`
				window.open(teamLink,"_blank")
			},
			 handleAvatarSuccess(res, file) {
				 if (res.code==1) {
				 	this.sectForm.thumb = res.data.src;
					this.sectForm.cover = res.id
				 } else{
				 	this.$message.error(res.msg);
				 }
			},
			handleScroll() {
				const container = document.getElementById('scroll-container');
				const rect = container.getBoundingClientRect();
				const scrollTop = rect.top;
				const scrollHeight = container.scrollHeight;
				const clientHeight = container.clientHeight;
				const scrollBottom = scrollHeight + scrollTop - window.innerHeight;
				if (scrollBottom <= 0) {
					
				// 滚动到底部，加载下一页数据
				this.loadNextPage();
				}
			},
			loadNextPage() {
				if(!this.pageover){
					this.loadingstr = '已经没有更多的数据了';
					this.loading = true; 
				}
				if (this.loading) return; // 如果正在加载中，则不执行新的加载请求
    			this.loading = true; // 设置加载状态为true
				this.page++;
				this.getTopicListAdd();

			},
			getTopicListAdd(){
				
				
				let url = 'home/article_news/0';
				switch(this.hotTopicStatus){
					case 0:
					url = 'home/article_news/0';
					break;
					case 1:
					url = 'home/FPubArticleList';
					break;
					case 2:
					url = 'home/TjianArticleList';
					break;
					case 3:
					url = 'home/article_news/3';	
					break;
				}
				http.get(`${url}/${this.page}/${this.limit}`).then(res=>{
					if (res.data.code==1) {
						if(res.data.data.list.length == 0){
							this.pageover = false;
							this.loadingstr = '已经没有更多的数据了';
						}
						this.total = res.data.data.count;
						//this.topicList = res.data.data.list
						this.topicList = [...this.topicList, ...res.data.data.list];
						//console.log(this.topicList,88)
						this.loading = false; // 加载完成后，将加载状态设置为false
					}

				})
			}
	    }
	  }
</script>

<style scoped>
	.navhengfu {
		background: url('@/static/icons/hengfu.png') center center no-repeat;
		height: 52px;
		position: absolute;
		width: 1900px;
		top:70px;
		line-height: 52px;
		font-size: 16px;
		cursor: pointer;

	}

	.navhengfu .navtxt {
		padding-left:20px;
		background: url('@/static/icons/notice.png') left center no-repeat;
		color:red;
	}
	.Tieba {
		overflow: hidden;
		display: flex;
		justify-content: center;
		flex-wrap: nowrap;
		padding-top: 55px;
	}
	.loginShow /deep/ .el-dialog {
		width: 380px;
	}
	.loginShow /deep/ .el-dialog__header {
		height: 60px;
		line-height: 60px;
	}
	.loginShow /deep/ .el-dialog__title {
		font-size: 26px;
		color: #2882FE;
	}
	.loginShow /deep/ .el-dialog__body {
		padding: 30px 10%;
	}
	.loginShow /deep/ .el-input--prefix .el-input__inner {
		padding-left: 40px;
	}
	.loginShow /deep/ .el-input__prefix img {
		margin: 9px 0  0 5px;
	}
	.loginShow .phoneCode /deep/ .el-input__suffix{
		display: flex;
		right: 0px;
	}
	.loginShow .phoneCode /deep/ .el-input__suffix-inner {
		margin: auto;
		cursor: pointer;
		height: 4vh;
	}
	.loginShow .phoneCode /deep/ .el-input__suffix-inner img {
		height: 4vh;
	}
	.loginShow .phoneCap {
		background: #2882FE;
		color: #fff;
		height: 4.3vh;
		line-height: 4.3vh;
		white-space: nowrap;
		padding: 0 2.3vw;
		box-sizing: border-box;
		border: 1px solid #E9E9E9;
		border-radius: 4px;
		cursor: pointer;
		font-size:calc(100vw * 15 / 1920);
	}
	.loginShow .loginBtn {
		width: 100%;
		background: #2882FE;
		font-size: 17px;
		margin-top: 20px;
	}
	.loginShow .forgotPwd {
		margin-top: 10px;
		width: fit-content;
		color: #666666;
		line-height: 16px;
		font-size: 13px;
		cursor: pointer;
	}
	.loginShow .toRegister {
		margin-top: 50px;
		text-align: center;
		color: #666666;
		line-height: 16px;
		font-size: 14px;
		cursor: pointer;
	}
	.loginShow .toRegister span {
		color: #2882FE;
	}
	.loginShow /deep/ .el-form-item:last-child {
		margin-bottom: 0;
	}
	.dialog-footer /deep/ .el-button--primary {
		width: 280px;
		width: 50%;
		height: 40px;
		background: #2882FE;
		border-radius: 4px;
		font-size: 16px;
		color: #FFFFFF;
		padding: 0;
		margin-bottom: 6px;
	}
	.dialog-footer /deep/ .el-checkbox{
		line-height: 14px;
		display: flex;
		justify-content: center;
	}
	.dialog-footer /deep/ .el-checkbox__label {
		font-size: 12px;
		line-height: 14px;
		color: #969696 ;
	}
	.dialog-footer .el-checkbox__label span.red {
		color: #DF021C;
	}
	.dialog-footer .el-checkbox__label span {
		color: #2882FE;
	}
	.dialog-footer /deep/ .el-checkbox__inner {
		border: 1px solid #969696;
	}
	.dialog-footer /deep/ .el-checkbox__input {
		height: 14px;
	}
	.createSuccess /deep/ .el-dialog--center .el-dialog__body {
		text-align: center;
		line-height: 60px;
	}
	.createSuccess /deep/ .el-dialog__footer {
		line-height: 70px;
	}
	

	.lunbo {
		padding: 0 8px 0 0;
		box-sizing: border-box;
		height: 35px;
		line-height: 35px;
		text-overflow: ellipsis;
		word-break: keep-all;
		white-space: nowrap;
		overflow: hidden;
		flex: 1;
		width: 200px;
	}
	.lunbo /deep/ .el-carousel__indicator--vertical {
		padding: 0;
		width: 0;
	}
	.lunbo /deep/ .el-carousel__container {
		height: 35px;
	}
	.lunbo.el-carousel.el-carousel--vertical {
		width: 200px!important;
	}

	.notice {
		font-size: 14px;
		color: #E83655;
		text-align: right;
		height: 18px;
		line-height: 18px;
		width: 1200px;
		display: flex;
		align-items: center;
		position: absolute;
		top: 76px;
		justify-content: right;
	}

	.notice img {
		width: 13px;
		height: 13px;
		margin-right: 4px;
	}
	.c_left {
		width: 387px;
		overflow: hidden;
		margin-left: 13px;
	}
	.hotTopicName {
		display: flex;
		align-items: center;
		line-height: 23px;
	}

	.titnav{
		font-size: 16px;
		height: 40px;
		display: flex;
		border-bottom: #dbdbdb 1px solid;
		background-color: #FFFFFF;
		line-height: 42px;
		justify-content: center;
	}
	.titnav a{
		padding: 0 30px;
		cursor: pointer;
	}
	.titnav a.active>span ,  .nav a:hover>span {
			/*关键代码*/
			padding-bottom: 7px;
			border-bottom:  3px solid #0363f4;
		}
	

	.hotTopicName img {
		margin-right: 4px;
	}
	.hotTopicName span {
		margin: 0 10px;
	}
	.hotTopicName a {
		cursor: pointer;
		padding-left: 10px;
	}
	/* 左上 */
	.handleBox {
		padding: 22px;
		padding-bottom: 11px;
		box-sizing: border-box;
		overflow: hidden;
		background: url('@/static/icons/logoBg.png') no-repeat;
		background-size: 100% 100%;
		margin-bottom: 10px;
		display: flex;
		flex-wrap: wrap;
	}
	.logo,.handleBtn,.release {
		float: left;
	}
	.handleBox .userInfo {
		width: 100%;
		line-height: 40px;
	}
	.handleBox .Avatar {
		width: 100px;
		height: 100px;
		border-radius: 50%;
		margin: auto;
	}
	.handleBox .unerName {
		width: 100%;
		line-height: 22px;
		color: #fff;
		font-size: 16px;
		display: flex;
		justify-content: center;
	}
	.handleBox .unerName div {
		position: relative;
	}
	.handleBox .unerName span {
		font-size: 12px;
		color: red;
		position: absolute;
		right: -30px;
	}
	.handleBox .unerName span:hover{
		cursor: pointer;
	}
	.handleBox .logo{
		width: 198px;
		
		margin-bottom: 16px;
		margin-left: 25px;
		image-rendering: -webkit-optimize-contrast; /* 处理模糊代码 */
	}
	.handleBox .handleBtn {
		width: 100%;
		padding: 0 37px;
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
	}
	.handleBox .handleBtn span {
		background-color: #fff;
		font-size: 13px;
		height: 30px;
		line-height: 30px;
		padding: 0 25px;
		cursor: pointer;
	}
	.handleBox .handleBtn span img {
		margin-right: 4px;
	}
	.handleBox .release,.handleBox .release1 {
		width: 100%;
		margin-top: 18px;
		box-sizing: border-box;
		padding: 0 37px;
	}
	.handleBox .release span,.handleBox .release1 span {
		display: block;
		height: 25px;
		line-height: 25px;
		background-color: #fff;
		font-size: 13px;
		color: #0A54D6;
	}
	.handleBox .release span:hover,.handleBox .release1 span:hover {
		cursor: pointer;
	}
	.handleBox .release1 {
		display: flex;
		justify-content: space-between;
	}
	.handleBox .release1 span{
		width: 46%;
	}
	/* 火热门派 */
	.hotSect {
		background-color: #fff;
		border-radius: 10px 10px 0 0;
	}
	.hotSect .hotSectOut {
		padding: 0 18px 0 14px;
		background: linear-gradient(178deg, #2365DB 0%, #5B8CE4 100%);
		border-radius: 10px 10px 0 0;
	}
	.hotSect .hotSectTitle{
		display: flex;
		align-items: center;
		justify-content: space-between;
		box-sizing: border-box;
		color: #fff;
	}
	.sectTitleLeft {
		width: fit-content;
		line-height: 41px;
		font-size: 16px;
		display: flex;
		align-items: center;
	}
	.sectTitleLeft img {
		margin-right: 9px;
	}
	.sectTitleright {
		line-height: 41px;
		font-size: 12px;
		display: flex;
		align-items: center;
	}
	.sectTitleright:hover {
		text-decoration: underline;
		cursor: pointer;
	}
	.sectTitleright img {
		width: 6px;
		height: 11px;
		margin-left: 5px;
	}
	.hotSect .hotSectList {
		font-size: 10px;
		overflow: hidden;
	}
	.hotSectItem {
		padding: 10px 8px;
		display: flex;
		line-height: 15px;
		overflow: hidden;
		align-items: center;
		justify-content: space-between;
	}
	.hotSectItem:hover {
		background: #E6EEFB;
		cursor: pointer;
	}
	.hotSectItem:last-child {
		padding-bottom: 14px;
	}
	.hotSectItem img {
		width: 45px;
		height: 46px;
		border-radius: 50%;
		margin-right: 8px;
		image-rendering: -webkit-optimize-contrast; /* 处理模糊代码 */
	}
	.hotSectItem .box {
		width: 85%;
	}
	.box_title {
		display: flex;
		justify-content: space-between;
		flex-wrap: nowrap;
		height: 22px;
		margin-bottom: 6px;
		line-height: 22px;
	}
	.box_cent {
		width: 75%;
		text-align: left;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		font-size: 13px;
		color: #A8A8A8;
	}
	.sectName{
		color: #5C5C5C;
		font-size: 14px;
	}
	.sectName span{
		color: #F90C0C;
	}
	.interest{
		width: 55px;
		height: 22px;
		line-height: 22px;
		background: #FAB75D;
		border-radius: 9px;
		color: #fff;
	}
	.grcyInterest {
		background-color: #ccc;
	}
	/* 猜球 */
	.guessBall {
		margin-top: 13px;
	}
	.guessBall .guessBallOut {
		padding: 0 18px 0 14px;
		background: #D66F0A;
		border-radius: 10px 10px 0 0;
	}
	.guessBall .guessBallTilte {
		padding: 11px 0 11px;
		color: #fff;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.guessBall .guessBallTilte .sectTitleright {
		width: auto;
	}
	.guessBall .guessBallTilte .titlebox {
		height: 36px;
		line-height: 36px;
		border-bottom: #E9EEF3 1px solid;
	}
	.guessBall .guessBallTilte .ballIcon {
		width: 45px;
		height: 18px;
		margin-right: 2px;
	}
	.guessBall .guessBallTilte span{
		line-height: 18px;
		font-size: 16px;
	}
	.guessBall .guessBallCent .guessCentItem {
		display: flex;
		justify-content: space-between;
		font-size: 10px;
		align-items: center;
		padding: 13px 12px 18px;
		background-color: #fff;
		margin-bottom: 8px;
		border-radius: 10px;
	}
	.guessBall .guessBallCent .guessCentItem:first-child {
		border-radius: 0 0 10px 10px;
	}
	.ballTeam.yTeam {
	}
	.ballTeam {
		width: 50px;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		overflow: hidden;
	}
	.ballTeam img{
		width: 45px;
		height: 45px;
		border-radius: 50%;
		image-rendering: -webkit-optimize-contrast; /* 处理模糊代码 */
	}
	.ballTeam div {
		font-size: 10px;
		height: 20px;
		line-height: 20px;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		font-size: 13px;
	}
	/* 积分榜 */
	.Billboard {
		margin-top: 13px;
		background-color: #fff;
		margin-bottom: 10px;
	}
	.BillboardTitle {
		line-height: 38px;
		color: #fff;
		text-align: center;
		display: flex;
		justify-content: space-between;
	}
	.paycoin {
		position: absolute;
		right: -38px;
		top: 59%;
		transform: translate(-50%, -50%);
		min-width: 80px;
		height: 30px;
		color: white;
		line-height: 30px;
		font-size: 13px;
		text-align: center;
		border-radius: 30px;
		background: linear-gradient(90deg, #03a9f4, #f441a5, #ffeb3b, #03a9f4);
		text-decoration: none;
		text-transform: uppercase;
		background-size: 400%;
		z-index: 1;
		font-weight: normal;
		padding: 0 8px;
	}
	.paycoin:hover {
	    /* animation要和@keyframes搭配使用，move是随意起的一个动画名称，也是@keyframes规则的名称，
	       8s表示一个循环，infinite表示无限循环下去，alternate表示动画会在每次循环之间交替反向播放 */
	    animation: move 8s infinite alternate;
	}
	@keyframes move {
	    /* 100%表示最终时间达到位置，%0可以省略，默认初始 */
	    100% {
	        background-position: -400% 0;
	    }
	}
	.paycoin:before {
	    content: "";
	    position: absolute;
	    left: -5px;
	    right: -5px;
	    top: -5px;
	    bottom: -5px;
	    /* 以下三个和a元素保持一致 */
	    /*background: linear-gradient(90deg, #03a9f4, #f441a5, #ffeb3b, #03a9f4);*/
	    background-size: 400%;
	    border-radius: 50px;
	    /* 将元素内容模糊化 */
	    filter: blur(20px);
	    z-index: -1;
	}
	.paycoin:hover:before {
	    animation: move 8s infinite alternate;
	}
	.BillboardTitle div {
		width: 190px;
		text-align: center;
		background: #05A829;
		cursor: pointer;
		box-shadow: 0px 5px 9px 1px rgba(2,128,30,0.21);
	}
	.BillboardTitle .scoreBoard {
		border-radius: 2px 0px 41px 2px;
	}
	.BillboardTitle .otherBoard {
		background: #05A829;
		box-shadow: 0px 5px 9px 1px rgba(2,128,30,0.21);
		border-radius: 0px 2px 2px 41px;
	}
	.BillboardTitle .scoreSelect {
		background: #07C631;
		border-radius: 1px 41px 0px 1px;
	}
	.BillboardTitle .otherSelect {
		background: #07C631;
		border-radius: 41px 0px 1px 1px;
	}
	.Billboard .teams,.hotSect .teams {
		margin: 10px 29px;
		display: flex;
		justify-content: space-between;
		line-height: 22px;
		align-items: center;
		color: #333333;
		font-size: 15px;
	}
	.lookcoin {
		color: #fb8c00;
		font-size: 13px;
		line-height: 32px;
		margin-right: 30px;
		text-align: right;
		height: 32px;
		width: 66px;
		float: right;
		background: url(@/static/icons/vcoin.png) left center no-repeat;
	}
	.Billboard .teams div,.hotSect .teams div {
		height: 22px;
		line-height: 22px;
		cursor: pointer;
	}
	.Billboard .teams div /deep/ .el-divider--horizontal {
		width: 21px;
		height: 2px;
		background: #06C631;
		border-radius: 1px;
		margin: 0 auto;
	}
	.hotSect .teams div /deep/ .el-divider--horizontal {
		width: 21px;
		height: 2px;
		background: #2365DB;
		border-radius: 1px;
		margin: 0 auto;
	}
	.BillboardNav {
		height: 25px;
		line-height: 25px;
		background: #EDFDF0;
		border-radius: 2px;
		font-size: 14px;
		color: #707070;
		display: flex;
		justify-content: space-around;
		align-items: center;
		margin: 0 15px;
	}
	.BillboardNav span {
		width: 18%;
	}
	.scorersList .BillboardNav span {
		width: 25%;
	}
	.scorersList .BillboardNav span:first-child {
		width: 44px;
	}
	.BillboardItem {
		height: 32px;
		line-height: 32px;
		display: flex;
		justify-content: space-around;
		align-items: center;
		color: #333;
		font-size: 13px;
		margin: 0 15px;
	}
	.BillboardItem:hover {
		cursor: pointer;
	}
	.BillboardItem span {
		width: 16%;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	.scorersList .BillboardItem span {
		width: 25%;
		font-size: 14px;
	}
	.BillboardItem span:first-child {
		display: inline-block;
		width: 18px;
		height: 18px;
		margin: 0 20px;
		text-align: center;
		line-height: 18px;
		background: #E6EEFB;
		border-radius: 2px;
		font-size: 15px;
		color: #8A8989;
	}
	.scorersList .BillboardItem span:first-child {
		margin: 0 13px;
	}
	.BillboardItem span:nth-child(2){
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		font-size: 14px;
	}
	.BillboardItem:nth-child(-n+3) span:first-child {
		background: #07C631;
		color: #fff;
	}
	.c_cent {
		width: 800px;
		overflow: hidden;
	}
	/* 热门方案 */
	.c_cent .hotTopic {
		margin-bottom: 2px;
	}
	.hotTopicTitle  {
		padding: 10px 20px 7px 18px;
		background-color: #fff;
		background: linear-gradient(-15deg, #3789EF 0%, #195DD5 100%);
		border-radius: 10px 10px 0px 0px;
		color: #fff;
	}
	.hotTopicTitle {
		height: 24px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.hotTopicTitle {
		padding: 10px 20px 7px 18px;
	}
	.hotTopicItem {
		display: flex;
		align-items: center;
		padding: 12px 10px;
		background-color: #fff;
		margin-bottom: 5px;
		box-shadow: 0px 4px 13px 0px rgba(0,0,0,0.15);
		border-radius: 4px;
		position: relative;
	}
	.hotTopicItem .isFree {
		position: absolute;
		width: fit-content;
		height: 27px;
		line-height: 27px;
		right: 0;
		top: 0;
		background-color: #DF021C;
		color: #fff;
		font-size: 13px;
		padding: 0 18px;
		border-radius: 0 4px 0 4px;
	}
	.hotTopicItem .isFree.buzhongquan {
		background-color: #0629c6;
	}
	.hotTopicItem .isFree.fensi {
		background-color: #FAB75D;
	}
	.hotTopicItem .toppingImg {
		width: 45px;
		height: 45px;
		position: absolute;
		right: 0;
		top: 0;
		image-rendering: -webkit-optimize-contrast; /* 处理模糊代码 */
	}
	.hotTopicItem:last-child {
		margin-bottom: 13px;
	}
	.hotTopicItem /deep/ .el-divider--vertical {
		width: 1px;
		height: 76px;
		background: #B6CBF0;
		margin: 0 18px;
		margin-top:19px;

	}
	.gameCentNum .el-divider--vertical {
		margin-top:19px;
	}
	.hotTopicItem .hotTopicLeft {
		width: 80px;
		font-size: 13px;
		text-align: center;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		align-items: center;
	}
	.tipUser {
		width: 80px;
		height: 55px;
		line-height: 55px;
		margin-bottom: 9px;
	}
	.hotTopicLeft img {
		width: 60px;
		height: 55px;
		border-radius: 50%;
		margin: auto;
		image-rendering: -webkit-optimize-contrast; /* 处理模糊代码 */
	}
	.hotTopicLeft .tip1 {
		width: 100%;
		color: #212121;
		line-height: 14px;
		margin-bottom: 6px;
	}
	.hotTopicLeft .tip1:hover {
		color: #0A54D6;
		text-decoration: underline;
		cursor: pointer;
	}
	.hotTopicLeft .tip2 {
		width: 100%;
		font-weight: bold;
		color: #000000;
		line-height: 15px;
		cursor: pointer;
	}
	.hotTopicBox  /deep/  .Pagin {
		height: 90px;
		background-color: #fff;
		margin-bottom: 15px;
		border-radius: 10px;
	}
	.hotTopicItem .hotTopicRight {
		display: flex;
		text-align: left;
		width: 100%;
	}
	.hotTopicItem .hotTopicRight:hover {
		cursor: pointer;
	}
	.hotTopicCent {
		width: 540px;
		position: relative;
	}
	.hotTopicNum {
		height: fit-content;
		margin: auto;
		display: flex;
		margin-left: 15px;
		font-weight: normal;
	}
	.hotTopicNum div {
		line-height: 14px;
		margin-right: 20px;
		display: flex;
		align-items: center;
		font-size: 13px;
		color: #444545;
	}
	.hotTopicNum div:last-child {
		margin-bottom: 0;
	}
	.hotTopicNum img {
		width: 16px;
		height: 14px;
		margin-right: 9px;
	}
	.saveTagBox {
		position: relative;
		display: flex;
		flex-wrap: wrap;
		line-height: 20px;
		/* width: 70px; */
		height: 18px;
		overflow: hidden;
		max-width: 278px;
		margin: auto 0;
	}
	.saveTagBox span {
		display: block;
		text-align: center;
		margin-right: 4px;
		color: #62b0ed;
		border: 1px solid #cde9ff;
		background-color: #f3f9fd;
		border-radius: 10px;
		line-height: 18px;
		height: 18px;
		padding: 0 6px;
		font-size: 12px;
		box-sizing: border-box;
		font-weight: normal!important;
		/* width: 100%;
		margin-bottom: 10px; */
	}
	.saveTagBox span:last-child  {
		margin-bottom: 0;
	}
	.saveTagBox span.lian {
		color: #ff5107;
		border: 1px solid #ffdacb;
		background-color: #fff8f7;
	}
	.saveTagBox span.season {
		color: #f16529;
		background-color: #FAF3E7;
    	border: 1px solid #e2a47d;
	}
	.saveTagBox span.mother {
		color: #008000;
		background-color: #F4FCE9;
   		border: 1px solid #D5E7BC;
	}
	.saveTagBox span.week {
		border: solid 1px #f7c9a4;
		background-color: #fffbf3;
		color: #cd8663;
	}
	.hotTopicCent .topicTitle{
		height: 25px;
		line-height: 18px;
		font-size: 16px;
		font-weight: bold;
		color: #0E0E0E;
		margin-bottom: 3px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		/* display: flex; */
	}
	.hotTopicRight:hover .topicTitle {
		color: #0A54D6;
		cursor: pointer;
	}
	.topicTeams {
		line-height: 17px;
		margin-top:7px;
	}
	.topicTeams .typeName {
		height: 20px;
		background: #0A54D6;
		border-radius: 10px;
		padding: 0 15px;
		margin-right: 19px;
		font-size: 13px;
		color: #FFFFFF;
	}
	.topicTeams .battleTeam {
		font-size: 14px;
		color: #444545;
		line-height: 16px;
	}
	.topicTeams .battleTeam /deep/ .el-divider--vertical {
		height: 10px;
		margin: 0 16px 0 13px;
	}
	.topicTeams .battleTeam a:hover {
		color: #0A54D6;
		cursor: pointer;
		text-decoration: underline;
	}
	.hotTopicCent .topicDetails {
		height: 34px;
		line-height: 18px;
		overflow: hidden;
		font-size: 13px;
		color: #444545;
		margin-top: 10px;
		text-overflow: -o-ellipsis-lastline;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	/******************************************/
	.gameTopicList {
		padding: 10px;
		background-color: #fff;
		border-radius: 0 0 10px 10px;
	}
	.gameTopicItem {
		height: 100px;
		border-radius: 12px;
		padding: 10px 20px;
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		align-items: start;
	}
	.gameTopicItem .outbox {
		display: flex;
		position: relative;
	}
	.gameTopicItem .outbox .mrsimg{
		position: absolute;
		right: 212px;
	}
	.gameTopicItem:hover {
		background: rgba(67,124,224,0.22);
		cursor: pointer;
	}
	.gameTopicItem .userImg {
		width: 60px;
		height: 60px;
		border-radius: 50%;
		margin-right: 20px;
		
		image-rendering: -webkit-optimize-contrast; /* 处理模糊代码 */
	}
	.gameTopicCent {
		line-height: 50px;
		text-align: left;
		position: relative;
	}
	.gameTopicCent .gameCentTitle {
		color: #0A54D6;
		line-height: 22px;
		font-weight: bold;
		font-size: 17px;
		display: flex;
		align-items: center;
		overflow: hidden;
		width: 690px;
	}
	.gameTopicCent .gameCentTitle .nameTitle {
		max-width: 58%;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		display: inline-block;
	}
	.gameTopicCent .gameCentTitle a {
		position: absolute;
		right: -33px;
		top: 18%;
		transform: translate(-50%, -50%);
		min-width: 80px;
		
		color: white;
		line-height: 30px;
		font-size: 13px;
		text-align: center;
		border-radius: 10px;
		background: linear-gradient(90deg, #03a9f4, #f441a5, #ffeb3b, #03a9f4);
		text-decoration: none;
		text-transform: uppercase;
		background-size: 400%;
		z-index: 1;
		font-weight: normal;
		padding: 0 8px;
	}
	.gameTopicCent .gameCentTitle .ltlv{
		background: linear-gradient(90deg, #D5833B, #E0742B, #E95918, #E54912);
		right: 68px;
	}
	.gameTopicCent .gameCentTitle .freecoins {
		background: linear-gradient(90deg, #03a9f4, #446FD6, #3ba7ff, #03a9f4);
	}
	.gameTopicCent .gameCentTitle a:hover {
	    /* animation要和@keyframes搭配使用，move是随意起的一个动画名称，也是@keyframes规则的名称，
	       8s表示一个循环，infinite表示无限循环下去，alternate表示动画会在每次循环之间交替反向播放 */
	    animation: move 8s infinite alternate;
	}
	@keyframes move {
	    /* 100%表示最终时间达到位置，%0可以省略，默认初始 */
	    100% {
	        background-position: -400% 0;
	    }
	}
	.gameTopicCent .gameCentTitle a:before {
	    content: "";
	    position: absolute;
	    left: -5px;
	    right: -5px;
	    top: -5px;
	    bottom: -5px;
	    /* 以下三个和a元素保持一致 */
	    /*background: linear-gradient(90deg, #03a9f4, #f441a5, #ffeb3b, #03a9f4);*/
	    background-size: 400%;
	    border-radius: 50px;
	    /* 将元素内容模糊化 */
	    filter: blur(20px);
	    z-index: -1;
	}
	.gameTopicCent .gameCentTitle a:hover:before {
	    animation: move 8s infinite alternate;
	}

	
	.gameCentTitle .el-tag {
		margin-right: 10px;
	}
	.gameTopicCent .gameCentTitle div{
		display: flex;
		margin-left: 30px;
		height: 30px;
	}
	.gameTopicCent .gameCentTitle div span {
		display: inline-block;
		width: 50px;
		height: 19px;
		line-height: 19px;
		margin: auto;
		background: #FAB75D;
		text-align: center;
		color: #fff;
		font-weight: normal;
		font-size: 12px;
		border-radius: 12px;
	}
	.gameTopicCent .gameCentTitle div span.grcyInterest {
		background-color: #ccc;
	}
	.gameTopicCent .gameCentTitle div:hover {
		cursor: pointer;
	}
	.gameTopicCent .gameCentNum {
		color: #212121;
		font-size: 14px;
		display: flex;
		border-bottom: #cde9ff 1px solid;
	}
	.gameTopicCent .gameCentNum span {
		margin-right: 10px;
	}
	.gameTopicCent .gameCentNum .timeclass{
		color: #000000;
		font-size: 14px;
		margin-right: 10px;
	}
	.gameTopicCent .gameCentNum .timeclass:hover,.gameCentNum span:first-child:hover {
		color: #0A54D6;
		text-decoration: underline;
	}
</style>
